/**
 * @generated SignedSource<<6109c01c0559b2d0812b75c892a215b7>>
 * @relayHash 8d49f086e404cd774990851cc2a7daa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "accountIds"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "accountIds",
      "variableName": "accountIds"
    }],
    v2 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v3 = {
      "kind": "ScalarField",
      "name": "accountStatus"
    },
    v4 = {
      "kind": "ScalarField",
      "name": "accountId"
    },
    v5 = {
      "kind": "ScalarField",
      "name": "name"
    },
    v6 = {
      "kind": "ScalarField",
      "name": "picture"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "fetchUsersQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v5 /*: any*/, v6 /*: any*/]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "fetchUsersQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "name": "__typename"
        }, v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v5 /*: any*/, v6 /*: any*/]
      }]
    },
    "params": {
      "id": "f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def",
      "metadata": {},
      "name": "fetchUsersQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "55c7a5d564d3036b3714730d97d87482";
export default node;